import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56ef8851"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title bg-dark" }, "All Paladins ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Total NFTs: 1000", -1))
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = { class: "progress bg-dark mt-1" }
const _hoisted_8 = { class: "flex mb-5 row" }
const _hoisted_9 = { class: "flex-1 m-2 col-sm-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FarmerRewardDisplay = _resolveComponent("FarmerRewardDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, "NFTs Staked: " + _toDisplayString(_ctx.farmAcc.gemsStaked), 1),
    _createElementVNode("div", _hoisted_5, "Total PALD Earned: " + _toDisplayString(_ctx.farmAcc.rewardA.funds.totalAccruedToStakers), 1),
    _createElementVNode("div", _hoisted_6, [
      _createTextVNode("Percentage Staked: " + _toDisplayString(_ctx.farmAcc.gemsStaked * 100 / 1000) + "% ", 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "progress-bar progress-bar-info bg-info",
          role: "progressbar",
          "aria-valuenow": "100",
          "aria-valuemin": "0",
          "aria-valuemax": "1000",
          style: _normalizeStyle({ 'width': _ctx.farmAcc.gemsStaked * 100 / 1000  + '%'})
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.farmAcc.gemsStaked) + " / 1000 ", 1)
        ], 4)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_FarmerRewardDisplay, {
          key: _ctx.farmerAcc.rewardA,
          farmReward: _ctx.farmAcc.rewardA,
          reward: _ctx.farmerAcc.rewardA,
          title: "Your Rewards"
        }, null, 8, ["farmReward", "reward"])
      ])
    ]),
    _createElementVNode("button", {
      class: "btn is-dark mb-5",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshFarmer && _ctx.refreshFarmer(...args)))
    }, " Refresh account ")
  ]))
}